import { apiPost } from '../_common';

export default {
  create(request) {
    return apiPost('/magenta/fulfillment/subscription-box-order-return', request)
      .then(result => result.response);
  },
};
